import isEqual from 'lodash/isEqual';
import { combineWhereClauses } from 'v2/core/services/queryBuilder/combineWhereClauses';
import {
  EmptyWhereClause,
  OperationType,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';

export const getCombinedWhereClause = (
  whereClause1: WhereClause,
  whereClause2: WhereClause,
) => {
  const isEmptyWhereClause1 = isEqual(whereClause1, EmptyWhereClause);
  const isEmptyWhereClause2 = isEqual(whereClause2, EmptyWhereClause);

  if (isEmptyWhereClause1 && isEmptyWhereClause2) {
    return EmptyWhereClause;
  }

  if (isEmptyWhereClause1 && !isEmptyWhereClause2) {
    return whereClause2;
  }

  if (!isEmptyWhereClause1 && isEmptyWhereClause2) {
    return whereClause1;
  }

  return combineWhereClauses(whereClause1, whereClause2, OperationType.AND);
};
